import ApplicationAdapter from './application';

export default class ThoughtBubbleFlowAdapter extends ApplicationAdapter {
  namespace = 'api/v2';
}
